const scrollManager = require('ui/core/scrollManager');

const onFragmentClick = event => {
	const el = event.target;
	const href = el && el.tagName === 'A' ? el.getAttribute('href') : null;
	const matches = href ? href.match(/^#.*/) : null;

	if (matches && matches.length) {
		event.preventDefault();
		let fragment = document.getElementById(href.replace('#', ''));
		if (fragment) {
			scrollManager(
				fragment,
				{
					duration: 500,
					priority: 5
				},
				el
			);
		}
	}
};

module.exports = {
	bind(el) {
		el.addEventListener('click', onFragmentClick);
	},
	unbind(el) {
		el.removeEventListener('click', onFragmentClick);
	}
};
